module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"artikelBilder":"Artikelbilder"},"en":{"artikelBilder":"Artikelbilder"}}')
  delete Component.options._Ctor
}
